<template>
  <div class="card">
    <card-header :title="'Orden #' + order.id">
      <template #badge>
        <status-badge status="failed_to_send" />
      </template>
      <template #actions>
        <button
          class="button-interactive flex items-center system-button"
          @click.prevent="collapsed = !collapsed"
        >
          <span class="text-sm mr-2">{{
            collapsed ? "Ver detalle completo" : "Colapsar"
          }}</span>
          <arrow-icon class="w-3 smooth" :class="[{ '-rotate-90': collapsed }]" />
        </button>
      </template>
    </card-header>

    <router-link
      v-if="order.diet && order.diet.pet"
      :to="{
        name: 'petsDetail',
        params: { id: order.diet.pet.id },
      }"
      class="flex items-baseline space-x-2 text-primary-500 mb-3"
    >
      <dog-icon
        v-if="order.diet.pet.breed.pet_type.slug === 'dog'"
        class="w-5 fill-current"
      />

      <cat-icon
        v-else-if="order.diet.pet.breed.pet_type.slug === 'cat'"
        class="w-5 fill-current"
      />
      <p class="font-medium">
        {{ order.diet.pet.name }}
      </p>
    </router-link>

    <div class="detail-grid">
      <detail-field label="Cliente">
        <router-link
          :to="{
            name: 'clientsDetail',
            params: { id: order.client.id },
          }"
          class="detail-link"
          >{{ order.client.name }} {{ order.client.last_name }}</router-link
        >
      </detail-field>

      <detail-field label="Método de entrega" :value="order.pickup_delivery ? 'Pick-Up' : 'Envío'" />
      <detail-field label="Semanas" :value="order.weeks" />
      <detail-field label="Fecha de creación" :value="formatDatetime(order.created_at)" />
      <detail-field label="Fecha de última actualización" :value="formatDatetime(order.updated_at)" />
      <detail-field
        label="Fecha de entrega programada"
        :value="formatDate(order.min_delivery_date)"
      />

      <detail-field
        v-if="order.delivery_date"
        label="Fecha de entrega realizada"
        :value="formatDatetime(order.delivery_date)"
      />
    </div>

    <div v-if="!order.pickup_delivery && order.address" class="mt-3 text-sm">
      <p class="font-medium">Dirección de entrega</p>
      <address-component
        :address="order.address"
        :branchId="order.branch_id"
      />
    </div>

    <div v-show="!collapsed">
      <div class="div-line"></div>

      <section-header title="Detalles" />

      <div class="detail-grid">
        <detail-field label="Razón de fallo" :value="order.fail_reason" />
      </div>

      <div v-if="order.shipping_price" class="mt-2">
        <detail-field label="Costo de envío" :value="integerToCurrency(order.shipping_price)" />
      </div>

      <div
        class="mt-2 text-sm"
        v-if="
          !order.pickup_delivery &&
          order.related_shipment_orders &&
          order.related_shipment_orders.length > 0
        "
      >
        <p class="font-medium">Orden enviada con las siguientes órdenes:</p>
        <div class="flex space-x-2">
          <p
            v-for="relatedOrder in order.related_shipment_orders"
            :key="relatedOrder.id"
            class="text-sm text-content-400"
          >
            #{{ relatedOrder.id }}
          </p>
        </div>
      </div>

      <p v-if="order.diet && order.diet.pet" class="font-medium text-primary-500 mt-2">
        {{ order.diet.pet.name }}
      </p>

      <p class="font-medium">Dieta</p>

      <diet :diet="order.diet" :weeks="order.weeks" />

      <p class="font-medium mt-2">Paquetes</p>

      <meal-set
        v-for="(mealSet, index) in order.meal_sets"
        :key="mealSet.id"
        :index="index + 1"
        :mealSet="mealSet"
      />

      <p class="font-medium mt-4">Inventario Requerido</p>

      <div v-for="category in order.summary" :key="category.id" class="my-2">
        <p class="font-medium">{{ category.name }}</p>

        <table class="table-auto mt-2 bg-white">
          <tbody>
            <tr
              v-for="subcategory in category.subcategories"
              :key="subcategory.id"
              class="border"
            >
              <td class="p-2 border-r">
                {{ subcategory.name }}
              </td>
              <td class="p-2 border-r">
                {{ subcategory.totalQuantity.toLocaleString() }}g
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import MealSet from "../models/MealSet";
import Diet from "../models/Diet";
import AddressComponent from "../ui/Address";
import { formatDate, formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Ready For Pickup Order",

  components: {
    MealSet,
    Diet,
    AddressComponent,
  },

  data() {
    return {
      collapsed: true,
    };
  },

  props: {
    order: Object,
  },

  methods: {
    formatDate,

    formatDatetime,

    integerToCurrency,
  },
};
</script>